export default __webpack_public_path__ + "static/media/2_Still.fccd1bb2.jpg";